import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-lfsapi/configuration'

const LFSConfigurationApi = {
  displayLeadFilterParameter (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/lead-filter-parameter`,
      input,
      success,
      failure
    )
  },
  detailLeadFilterParameter (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/lead-filter-parameter-detail`,
      input,
      success,
      failure
    )
  },
  addLeadFilterParameter (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/lead-filter-parameter`,
      input,
      success,
      failure
    )
  },
  updateLeadFilterParameter (input, success, failure) {
    return ajax.put(
      `${BASE_URL}/lead-filter-parameter`,
      input,
      success,
      failure
    )
  },
  deleteLeadFilterParameter (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/lead-filter-parameter-delete`,
      input,
      success,
      failure
    )
  },
  exportLeadFilterParameter (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/lead-filter-parameter-export`,
      input,
      success,
      failure
    )
  },
  importLeadFilterParameter (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/lead-filter-parameter-import`,
      input,
      success,
      failure
    )
  },
  listComplianceLeadFilterParameter (input, success, failure) {
    return ajax.get(
      `${BASE_URL}/lead-filter-parameter-compliance`,
      input,
      success,
      failure
    )
  },
  deleteComplianceLeadFilterParameter (input, success, failure) {
    return ajax.post(
      `${BASE_URL}/lead-filter-parameter-compliance?id=${input}`,
      input,
      success,
      failure
    )
  },
  addComplianceLeadFilterParameter (input, success, failure) {
    const config = { headers: { Compliance: 'Compliance' } }
    return ajax.postHeader(
      `${BASE_URL}/lead-filter-parameter`,
      input,
      success,
      failure,
      config
    )
  },
  importComplianceLeadFilterParameter (input, success, failure) {
    const config = { headers: { Compliance: 'Compliance' } }
    return ajax.postHeader(
      `${BASE_URL}/lead-filter-parameter-import`,
      input,
      success,
      failure,
      config
    )
  }
}

export { LFSConfigurationApi }
